import { Box, Typography } from '@mui/material';
import { PropsWithChildren, useEffect, useState } from 'react';
import { AuthLayout, CountdownTimer } from 'shared/components';
import { useUser } from 'shared/hooks';
import { checkDownTime, getNewCSTDate, getNewDateFromHours } from 'shared/utility';

export function DownTimePage({ children }: PropsWithChildren<{}>) {
  const user = useUser();
  const isInsightEmployee = user?.isInsightEmployee;
  const [downTime, setDownTime] = useState(() => checkDownTime());
  const [startTime, setStartTime] = useState(() => getNewCSTDate());

  const downTimeEnabled = user && !isInsightEmployee && downTime;

  useEffect(() => {
    const eventInterval = setInterval(() => {
      setDownTime(checkDownTime());
      setStartTime(getNewCSTDate());
    }, 60000);

    return () => clearInterval(eventInterval);
  }, []);

  return downTimeEnabled ? (
    <AuthLayout>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-around',
          alignItems: 'center',
          padding: 15,
          height: 200,
        }}
      >
        <Typography variant='h5'>
          <Box display={'flex'} gap={1}>
            Data is loading, please come back in
            <CountdownTimer startTime={startTime} endTime={getNewDateFromHours(downTime || '')} />
          </Box>
        </Typography>
      </Box>
    </AuthLayout>
  ) : (
    <>{children}</>
  );
}
